import React from 'react';
import { Datagrid, TextField, DateField, List } from 'react-admin';

export const logList = props => {
    return (<List empty={false} bulkActionButtons={false} {...props} sort={{ field: 'createdAt', order: 'DESC' }}>
        <Datagrid>
            <TextField label="Name" source="administratorName" />
            <TextField label="Merchant id" source="merchantId" />
            <TextField label="Email" source="customerEmail" />
            <TextField label="Customer name" source="customerName" />
            <TextField label="Points" source="points" />
            <TextField label="Reason" source="reason" />
            <DateField label="Created at" source="createdAt" showTime />
        </Datagrid>
    </List>);
};

export default logList;